module.exports = __webpack_public_path__ + "img/quati.18744090.png";